import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MomentModule } from '@fredjohnd/ngx-moment';
import { TranslateModule } from '@ngx-translate/core';
import {
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
  PerfectScrollbarModule
} from 'ngx-om-perfect-scrollbar';

import { PureFnModule } from '../../pipes/pure-fn/pure-fn.module';
import { SharedModule } from '../../shared.module';
import { GenerateApprovalWorkflowComponent } from './generate-approval-workflow.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: false,
  suppressScrollY: false
};

@NgModule({
  declarations: [GenerateApprovalWorkflowComponent],
  imports: [
    CommonModule,
    PerfectScrollbarModule,
    TranslateModule.forChild(),
    PureFnModule,
    MomentModule.forRoot(),
    SharedModule
  ],
  providers: [{ provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG }],
  exports: [GenerateApprovalWorkflowComponent]
})
export class GenerateApprovalWorkflowModule {}
